<script setup lang="ts">
import { usePageTitle } from '@/composables/usePageTitle.ts'
import { storeToRefs } from 'pinia'
import { watch } from 'vue'
import { useUserStore } from '@/stores/user.store.ts'
import router from '@/router.ts'
import { useTranslations } from '@/composables/useTranslations.ts'
import { getAnalyticsUrlByProjectKey } from '@/config/config.ts'

const { t } = useTranslations()
const userStore = useUserStore()
const { projectSelected } = storeToRefs(userStore)

watch(
  () => projectSelected.value,
  (project) => {
    if (project) {
      router.push({
        path: getAnalyticsUrlByProjectKey(project.key),
      })
    }
  },
)
usePageTitle('Dash super')
</script>
<template>
  <div class="flex flex-col items-center justify-center text-center">
    <img src="/empty_projects.png" alt="empty projects view" class="-m-12" />
    <div class="max-w-md">
      <h1 class="text-gray-600 text-md font-bold m-4">{{ t('welcome.description') }}</h1>
    </div>
  </div>
  <div class="pre-footer-text">
    {{ t('analytics.overviewDescription') }}
  </div>
</template>
